import React, { useEffect, useState } from 'react';

import MenuButton from '@/components/Header/MenuButton';
import { SidebarConsumer } from '@/components/Context/Sidebar';
import ProfileDropdown from '@/components/Header/ProfileDropdown';

import NavigationItem, { Props as NavigationItemProps } from './NavigationItem';
import classNames from 'classnames';
import { Button } from '../ui/button';
import { SunIcon } from 'lucide-react';

export interface StaticComponents {
  Item: React.FC<NavigationItemProps>;
}

function DarkModeToggle() {
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    document.body.classList.toggle('dark', isDark);
  }, [isDark]);

  const toggleDarkMode = () => {
    setIsDark((prev) => !prev);
  };

  return (
    <Button variant="outline" onClick={toggleDarkMode}>
      <SunIcon />
    </Button>
  );
}

const Header: React.FC & StaticComponents = (props) => (
  <nav className="bg-background shadow-sm">
    <SidebarConsumer>
      {({ isOpen, open, close }) => (
        <React.Fragment>
          <div className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8">
            <div className="relative flex justify-between h-16">
              <MenuButton isOpen={isOpen} onClick={isOpen ? close : open} />
              <div className="flex-1 flex items-center justify-center sm:items-stretch sm:justify-start">
                <div className="shrink-0 flex items-center">
                  <img className="block h-12 w-12" src={require('./logo.jpg')} alt="Kane Kitchen Admin" />
                </div>
                <div className="hidden sm:ml-6 sm:flex sm:space-x-6">{props.children}</div>
              </div>

              <div className="absolute space-x-2 inset-y-0 right-0 flex items-center sm:static sm:inset-auto sm:ml-6">
                <DarkModeToggle />
                <ProfileDropdown />
              </div>
            </div>
          </div>

          <div className={classNames('sm:hidden', !isOpen && 'hidden')}>
            <div className="pt-2 px-2 pb-4 space-y-2 flex flex-col">{props.children}</div>
          </div>
        </React.Fragment>
      )}
    </SidebarConsumer>
  </nav>
);

Header.Item = NavigationItem as any;
export default Header;
